module.exports = __webpack_public_path__ + "static/media/2.ffce0324.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/2.png
// module id = 726
// module chunks = 0